var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10005_17699)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM8 4.8C6.23269 4.8 4.8 6.23269 4.8 8C4.8 9.76731 6.23269 11.2 8 11.2C9.76731 11.2 11.2 9.76731 11.2 8C11.2 6.23269 9.76731 4.8 8 4.8ZM2.8 8C2.8 5.12812 5.12812 2.8 8 2.8C10.8719 2.8 13.2 5.12812 13.2 8C13.2 10.8719 10.8719 13.2 8 13.2C5.12812 13.2 2.8 10.8719 2.8 8ZM8 7.6C7.77909 7.6 7.6 7.77909 7.6 8C7.6 8.22091 7.77909 8.4 8 8.4C8.22091 8.4 8.4 8.22091 8.4 8C8.4 7.77909 8.22091 7.6 8 7.6ZM5.6 8C5.6 6.67452 6.67452 5.6 8 5.6C9.32548 5.6 10.4 6.67452 10.4 8C10.4 9.32548 9.32548 10.4 8 10.4C6.67452 10.4 5.6 9.32548 5.6 8Z",
    fill: "#051016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6 8C7.6 7.77909 7.77909 7.6 8 7.6C8.22091 7.6 8.4 7.77909 8.4 8C8.4 8.22091 8.22091 8.4 8 8.4C7.77909 8.4 7.6 8.22091 7.6 8Z",
    fill: "#051016"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10005_17699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.37273ed753e584de1aa6b99431aa1bf5.svg";
export { ForwardRef as ReactComponent };